// Jours calendaires en chaîne AAAA-MM-JJ, calculés en UTC pour ignorer les changements d'heure.
// Saison en MM-JJ, éventuellement à cheval sur deux années (ex. 10-01 → 02-28).

const DAY_MS = 86_400_000;

export function addDays(day: string, days: number): string {
  return new Date(Date.parse(`${day}T00:00:00Z`) + days * DAY_MS).toISOString().slice(0, 10);
}

/** Nombre de jours de `from` à `to` (négatif si `to` précède `from`). */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / DAY_MS);
}

/** MM-JJ existant (29 février compris). */
export function isMonthDay(value: string): boolean {
  const match = /^(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const month = Number(match[1]);
  const day = Number(match[2]);
  return month >= 1 && month <= 12 && day >= 1 && day <= new Date(Date.UTC(2024, month, 0)).getUTCDate();
}

export interface Season {
  from: string;
  to: string;
}

/** Le jour tombe-t-il dans la saison (bornes incluses) ? */
export function inSeason(day: string, season: Season): boolean {
  const monthDay = day.slice(5);
  return season.from <= season.to ? monthDay >= season.from && monthDay <= season.to : monthDay >= season.from || monthDay <= season.to;
}
